import styled from "styled-components";

export const Styles = styled.div`
  .print-table {
    width: 100%;
    border-collapse: collapse;
  }
  .pdf-container {
    padding: 0 75px;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
  }

  .pdf-title {
    margin-top: 0;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 20px;
    color: #000;
  }

  .pdf-table-wrapper {
    width: 100%;
    box-sizing: border-box;

    .table-div__body .table-div__cell {
      white-space: normal !important;
      overflow-wrap: anywhere;
      word-break: break-word;
      min-width: 0;
    }

    .table-div__body .table-div__cell > div {
      min-width: 0;
      width: 100%;
    }

    .table-div__body .table-div__row {
      align-items: flex-start !important;
    }

    .table-div__body .table-div__row:not(:first-child) .table-div__cell {
      align-items: flex-start !important;
    }

    .table-div__body .table-div__row:first-child .table-div__cell {
      align-items: center !important;
    }

    .table-div {
      border: none !important;
      padding-bottom: 0px !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
    }

    .table-div__header {
      display: none !important; /* Hide column headers */
    }

    .table-div__cell {
      border: none !important; /* Remove borders for rows and columns */
      padding: 4px 8px !important;
      font-size: 14px;
      color: #333;
      background: transparent !important;
      min-width: 0;
    }

    .table-div__row {
      border: none !important;
      margin-bottom: 8px; /* Improved spacing for PDF */
      width: 100% !important;
      &:hover .table-div__cell {
        background: transparent !important;
      }
    }

    .table-div__body {
      padding-top: 0px !important;
      overflow: visible !important;
    }
  }

  @page {
    size: A4;
    margin: 75px 0;
  }

  @media print {
    html,
    body {
      display: block !important;
      overflow: visible !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      visibility: visible !important;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }

    .page {
      margin: 0;
      padding: 0;
      width: 100%;
      height: auto !important;
      display: block !important;
      page-break-after: auto;
      break-after: auto;
    }

    .pdf-container {
      margin: 0;
      width: 100%;
      padding: 0 40px !important;
      overflow: visible !important;
      display: block !important;
      height: auto !important;
    }

    .pdf-table-wrapper,
    .table-div,
    .table-div__body {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
      scale: 1 !important;
      transform: none !important;
    }

    .table-div__row {
      break-inside: auto !important;
      page-break-inside: auto !important;
      display: grid !important;
      margin-bottom: 0px !important;
      align-items: flex-start !important;
    }

    .table-div__row:not(:first-child) .table-div__cell {
      align-items: flex-start !important;
    }

    .table-div__row:first-child .table-div__cell {
      align-items: center !important;
    }

    .table-div__cell {
      break-inside: auto !important;
      page-break-inside: auto !important;
      display: flex !important;
      height: auto !important;
      min-height: min-content !important;
      white-space: normal !important;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }
`;
